// eslint-disable-next-line react/jsx-props-no-spreading
import React from 'react';
import { Button } from 'antd';
import { textColor } from '@helpers/color';
import { BasicButtonProps } from './types';

const BasicButtonTxt = ({
  content,
  onClick,
  icon,
  loading,
  buttonColorType,
  ...props
}: BasicButtonProps) => {
  const buttonColor = {
    red: `${textColor.red} border-none`,
    green: `${textColor.green} border-none`,
    blue: `${textColor.blue} border-none`,
    white: `${textColor.white} border-none`,
  };
  const buttonColorStyle = buttonColorType && buttonColor[buttonColorType];

  return (
    <Button
      className={`flex flex-row items-end text-sm xs:text-sm sm:text-sm md:text-sm lg:text-sm xl:text-sm 2xl:text-sm ${buttonColorStyle}`}
      onClick={onClick}
      loading={loading}
      {...props}
    >
      {icon}
      {content}
    </Button>
  );
};
export default BasicButtonTxt;
